import * as styles from "../FieldWrapper/FieldWrapper.styles";
export var textarea = styles.input;